var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"android-order-icon",class:`android-order-icon--${_vm.size}`,attrs:{"viewBox":"0 0 24 24","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":_vm.path,"fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }